import { useEffect, useState } from 'react';
import { fetchRevisionesEquipo } from '../services/partes';
import type { RevisionReplicaRow } from '../types/clientes';

// Las revisiones de la puerta de la llamada, bajo demanda. Mismo patrón que
// `usePartesCliente`, y por la misma razón: hacen falta los TRES estados
// —«todavía no lo sé», «no lo he podido consultar» y «esta puerta no tiene
// revisiones»—, porque confundir los dos últimos hace que quien atiende le diga
// al cliente que no consta ninguna visita cuando lo que ha fallado es la
// consulta. Es el incumplimiento I1 de la feature base, ya corregido allí.
//
// Sin puerta identificada no se consulta nada: es la mitad de las llamadas, y no
// es un error.
export function useRevisionesEquipo(idEquipo: string | null): {
  revisiones: RevisionReplicaRow[];
  cargando: boolean;
  fallo: boolean;
} {
  // Igual que en `useLlamadaCompleta`: las revisiones se guardan junto a la
  // puerta que las pidió y solo se exponen si coincide. En el render en el que
  // llega la puerta nueva, el efecto todavía no ha corrido y `revisiones` son
  // las de la puerta ANTERIOR con `cargando` en false — o sea, la ventana en la
  // que el panel enseña el historial de otra puerta como si fuera de esta.
  // Hallazgo P3 del segundo revisor.
  const [dato, setDato] = useState<{ id: string; filas: RevisionReplicaRow[] } | null>(null);
  const [cargando, setCargando] = useState(false);
  const [fallo, setFallo] = useState(false);

  useEffect(() => {
    if (!idEquipo) {
      setDato(null);
      setCargando(false);
      setFallo(false);
      return;
    }
    let vigente = true;
    setCargando(true);
    setFallo(false);
    fetchRevisionesEquipo(idEquipo)
      .then((r) => {
        if (!vigente) return;
        setDato({ id: idEquipo, filas: r });
        setCargando(false);
      })
      .catch(() => {
        if (!vigente) return;
        setDato({ id: idEquipo, filas: [] });
        setCargando(false);
        setFallo(true);
      });
    return () => {
      vigente = false;
    };
  }, [idEquipo]);

  return {
    revisiones: dato && dato.id === idEquipo ? dato.filas : [],
    cargando: cargando || (idEquipo != null && dato?.id !== idEquipo),
    fallo,
  };
}
